'use client';
import { styled } from '@mui/material/styles';
import { neutral, warm, brandPrimaryADASoot } from '../../style/variables';

export const FooterContainer = styled('footer')(
  `
    --footer-max-width: 1200px;
    --footer-spacing-vertical: 1.5rem;
    --footer-color: ${neutral[50]};
    --background-color: ${neutral[900]};
    --bottom-background-color: ${neutral[800]};
    --bottom-color: ${neutral[0]};
    --border-color: ${warm[700]};
    --hover-color: ${brandPrimaryADASoot};
    --copyright-color: ${neutral[500]};
    --link-color: ${warm[400]};
  `,
  `
    background: var(--background-color);
    position: relative;
  `,
);

export const FooterNav = styled('nav')(
  ({ theme }) => `
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    max-width: var(--footer-max-width);
    margin: 0 auto;
    padding: 3rem var(--footer-spacing-vertical);
    flex-direction: column;

    ${theme.breakpoints.up('sm')} {
      flex-direction: row;
    }

    ${theme.breakpoints.up('lg')} {
      padding: 3rem 0;
    }
  `,
);

export const FooterBottom = styled('div')`
  background: var(--bottom-background-color);
  color: var(--bottom-color);
`;
